// Navigates to an alternate template (via the `view` URL parameter) to change
// how many items are shown per page on collection/search listing pages.
// Uses capture-phase stopPropagation so this select doesn't also trigger the
// facets AJAX refresh (see facets.js), since changing page size requires a
// real page load to pick up the alternate template's section settings.
document.addEventListener(
  'input',
  (event) => {
    if (event.target.closest('[data-page-size-select]')) {
      event.stopPropagation();
    }
  },
  true
);

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-page-size-select]');
  if (!select) return;

  const params = new URLSearchParams(window.location.search);
  params.delete('page');
  if (select.value) {
    params.set('view', select.value);
  } else {
    params.delete('view');
  }

  const query = params.toString();
  window.location.href = `${window.location.pathname}${query ? '?' + query : ''}`;
});
